module.exports = __webpack_public_path__ + "media/images/search-1f41d1c9e8774b91e755b2343881f60c.svg";